import { message } from 'antd';
import Action from '../Action';

export function login(data) {
	return (dispatch) =>
		new Promise((resolve) => {
			dispatch({ type: Action.LOGIN, data: data, user: data.data.user });
			setTimeout(() => resolve(true), 100);
		});
}

export function logout() {
	return (dispatch) =>
		new Promise((resolve) => {
			dispatch({ type: Action.LOGOUT });
			message.warning('You have been logged out!');
			setTimeout(() => resolve(true), 100);
		});
}
